import {setupDemoForm} from "layouts/_demo_form";
import "./demo.scss";

declare var $: any;

document.addEventListener("DOMContentLoaded", () => {
  setupDemoForm();
});

$(document).ready(() => {
  const carousel = $(".cards .owl-carousel");
  carousel.owlCarousel({
    loop: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true,
    items: 1,
    smartSpeed: 750,
    margin: 20,
    onChanged: (ev: any) => {
      const card = $(".cards .category-section").eq(ev.item.index % 3);
      const category = card.attr("data-category");
      $("ul.tabs li").removeClass("active");
      $('ul.tabs li[data-category="' + category + '"]').addClass("active");
    },
  });

  $("ul.tabs li").click(function (el: any) {
    const selectedCategory = $(this).attr("data-category");

    const items = $(".cards .owl-carousel .owl-item:not(.cloned)");
    let index = -1;

    for (let i = 0; i < items.length; i++) {
      const item = $(items[i]);
      const category = item.find(".category-section").attr("data-category");

      if (category === selectedCategory) {
        index = i;
        break;
      }
    }

    if (index === -1) {
      return;
    }

    carousel.trigger("to.owl.carousel", [index, 150, true]);
  });
});
